import { useTranslate } from "@refinedev/core";
import { Button, SectionHeader } from "@fawkes/ui";

import { FinanceConnectionBox } from "./FinanceConnectionBox";
import { GrootboekList } from "./GrootboekList";
import type { SettingsContext } from "./tiles/types";

// jve-settings-finance: the Financieel tile's detail screen — the React port of the Jmix "Financieel"
// settings. Hosts the two migrated sections of the tile: "Koppeling boekhouding" (the external
// accounting connection, FinanceConnectionBox) and "Grootboeknummers" (the ledger-account CRUD,
// GrootboekList). Rendered in-place by SettingsDashboard's detail switch with a "Terug" back button,
// mirroring the AiKoppelingDetail / GemeenteManagement detail pattern.
export function FinanceSettings({
  context,
  onBack,
}: {
  context: SettingsContext;
  onBack: () => void;
}) {
  const t = useTranslate();
  return (
    <div className="settings-finance-settings">
      <div className="settings-finance-detail-toolbar">
        <Button variant="secondary" onClick={onBack}>
          {t("common.back")}
        </Button>
        <SectionHeader>{t("instellingen.tile.finance.title")}</SectionHeader>
      </div>
      <p className="fawkes-muted settings-finance-detail__breadcrumb">
        {`${t("instellingen.title")} › ${context.label} › ${t("instellingen.tile.finance.title")}`}
      </p>

      <FinanceConnectionBox />
      <GrootboekList />
    </div>
  );
}
